import React from "react";
import styles from "./Skeleton.module.css";

export function SkeletonTabs() {
  return (
    <div className={styles.skeletonTabs}>
      <div className={styles.skeletonTab} />
      <div className={styles.skeletonTab} />
      <div className={styles.skeletonTab} />
    </div>
  );
}
